import React from 'react';
import type { ProjectIdentity } from '../../../types/project';
import type { FormSelectOption } from '../FormSelect/FormSelect';
import ProjectBadge from '../ProjectBadge/ProjectBadge';
import styles from './PlanNameWithProject.module.css';

interface PlanNameWithProjectProps {
  name: string | null | undefined;
  project?: ProjectIdentity | null;
  className?: string;
  nameClassName?: string;
}

const PlanNameWithProject: React.FC<PlanNameWithProjectProps> = ({
  name,
  project,
  className,
  nameClassName,
}) => {
  const displayName = name?.trim() || '—';

  return (
    <span className={[styles.wrap, className].filter(Boolean).join(' ')}>
      <span className={[styles.name, nameClassName].filter(Boolean).join(' ')}>{displayName}</span>
      <ProjectBadge project={project} />
    </span>
  );
};

export function createPlanSelectFormatters(
  plans: ReadonlyArray<{ id: number; project?: ProjectIdentity | null }>,
): {
  triggerFormat: (option: FormSelectOption) => React.ReactNode;
  optionFormat: (option: FormSelectOption) => React.ReactNode;
} {
  const projectByPlanId = new Map(plans.map((plan) => [String(plan.id), plan.project]));
  const format = (option: FormSelectOption) => (
    <PlanNameWithProject name={option.label} project={projectByPlanId.get(option.value)} />
  );

  return {
    triggerFormat: format,
    optionFormat: format,
  };
}

export default PlanNameWithProject;
